module.exports = __webpack_public_path__ + "static/media/c-pop-up-6.1379c8bb.png";